import React from 'react';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import { WatchTV, Page, TextPage, Settings, Recordings, Downloads } from 'Pages';
import { Device } from 'DeviceUtils';
import { createNavigationOptions, getMaterialTopBarOptions } from './navigationUtils';
import { useNavigationPropsContext } from './navigationPropsContext';

const Tab = createMaterialTopTabNavigator();

export const pageTypeEnum = Object.freeze({
    PAGE: 'page',
    EPG: 'epg',
    MENU: 'menu',
    TEXT_PAGE: 'textPage',
    SETTINGS: 'settings',
    DOWNLOADS: 'downloads',
    RECORDINGS: 'recordings'
});

const PAGE_TYPE_MAP = {
    [pageTypeEnum.EPG]: WatchTV,
    [pageTypeEnum.TEXT_PAGE]: TextPage,
    [pageTypeEnum.SETTINGS]: Settings,
    [pageTypeEnum.DOWNLOADS]: Downloads,
    [pageTypeEnum.RECORDINGS]: Recordings
};

interface MenuItem {
    label: string;
    type: any;
    slug: string;
    reference: string;
}

interface NavigationProps {
    videoStoreTab?: string;
}

const getComponentByPageType = (pageType: string | number) => PAGE_TYPE_MAP[pageType] || Page;

const createTopBarNavigationStack = (menuItem: { items: MenuItem[]; }) => () => {
    const { navigationProps } = useNavigationPropsContext() as { navigationProps: NavigationProps };

    let check = false;
    // TODO: mainly info, all changes here are responsible for updating locatio of the tab in the videostore. Sub-navigation as we can call it. for other purposses it is not neccesary, If was still blak for other paths than videstore, then try to revert and test...
    const initIndex = menuItem.items?.findIndex((item: MenuItem) => item.slug === navigationProps.videoStoreTab);

    const initialRouteName = menuItem.items.length > 0 && initIndex !== undefined && initIndex !== -1
        ? menuItem.items[initIndex].slug
        : menuItem.items[0].slug;

    const navigatorOptions = getMaterialTopBarOptions(menuItem.items.length);

    check = initIndex !== undefined && initIndex !== -1;

    const items = menuItem.items.map((item: MenuItem) => (
        <Tab.Screen
            name={item.slug}
            component={getComponentByPageType(item.type)}
            key={item.slug}
            options={{
                tabBarLabel: item.label && item.label.toUpperCase(),
                tabBarTestID: item.slug.toString(),
            }}
            initialParams={{
                reference: item.reference,
                withTvGuideButton: true,
            }}
        />
    ));

    return (
        <Tab.Navigator
            {...navigatorOptions}
            initialRouteName={initialRouteName}
        >
            {items}
        </Tab.Navigator>
    );
};

interface Stack {
    screen: React.ComponentType<any>;
    params?: {
        reference: string
    };
    navigationOptions?: (props: { navigation: any }) => any;
}

export const menuItemsStackFactory = (item) => {
    const stack: Stack = {
        screen: undefined,
        params: undefined
    };
    const hasSubPages = item.items && item.items.length > 0;
    const hasOneSubPages = item.items && item.items.length === 1;
    if (hasOneSubPages) {
        stack.screen = getComponentByPageType(item.items[0].type);
    } else if (hasSubPages) {
        stack.screen = createTopBarNavigationStack(item);
    } else {
        stack.screen = getComponentByPageType(item.type);
    }

    const pageReferenceValue = (): string => item.reference || (item.items.length > 0 ? item.items[0].reference : item.id);

    if (item.slug !== 'settings') {
        stack.params = {
            reference: pageReferenceValue()
        };
    }

    if (!Device.isTabletOrWeb || item.type !== pageTypeEnum.SETTINGS) {
        stack.navigationOptions = ({ navigation }) => createNavigationOptions(item, navigation);
    }

    return stack;
};
